import styled from 'styled-components';

const Image = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: opacity 300ms ease;
`;

export default Image;
